import { useState } from 'react';

/* ========================================================================= */
/* Hook(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/hooks/filters.d.ts').ApplyFacetsToFilterOptions}
 */
const applyFacetsToFilterOptions = (options, value, facets) => {
    if (facets) {
        return options.map((option) => {
            if (option.value !== undefined) {
                const facet = facets?.find((f) => f.key === String(option.value));
                option.disabled = facets && !facet && !value?.includes(option.value);
            }
            return option;
        });
    }
    return options;
};

/**
 * @hook useMultiSelectFilter
 * @type {import('$types/components/hooks/filters.d.ts').UseMultiSelectFilter}
 */
const useMultiSelectFilter = ({
    initialValue = [],
    options = [],
    facets
}) => {
    const [_value, setValue] = useState(initialValue || []);
    const [_facets, setFacets] = useState(facets || []);

    /** @type {(key: string) => void} */
    const addValue = (key) => {
        setValue([..._value, key]);
    };

    const clear = () => {
        setValue([]);
    };

    /** @type {(key: string) => void} */
    const removeValue = (key) => {
        let values = [..._value];
        const index = values.indexOf(key);
        if (index > -1) { values.splice(index, 1); }
        setValue(values);
    };

    /** @type {(key: string) => void} */
    const toggleValue = (key) => {
        if (_value.indexOf(key) === -1) {
            addValue(key);
        } else {
            removeValue(key);
        }
    };

    return {
        addValue,
        clear,
        options: facets ? applyFacetsToFilterOptions(options, _value, _facets) : options,
        removeValue,
        setFacets,
        setValue,
        toggleValue,
        value: _value
    };
};


/**
 * @hook useMultiSelectFilter
 * @type {import('$types/components/hooks/filters.d.ts').UseSingleSelectFilter}
 */
const useSingleSelectFilter = (params = {}) => {
    const [value, setValue] = useState(params.value || '');
    const options = params.options || [];

    return {
        options,
        value,
        setValue
    };
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export {
    useMultiSelectFilter,
    useSingleSelectFilter
};
